import React from 'react';
import './PageHeader.css';

const PageHeader = ({ subtitle }) => {
  return (
    <div className="page-header">
      <p className="page-subtitle">
        {subtitle}
      </p>
    </div>
  );
};

export default PageHeader;
